<template>
  <div>
    <v-expansion-panel-title @click="togglePanel" @contextmenu.stop="emit('right-click', $event)">
      <v-row v-if="isOpened" no-gutters @click.stop="">
        <v-col cols="3" style="display: flex; align-items: center">
          <v-text-field
            :class="dirtyClass"
            :model-value="name"
            color="primary"
            hide-details
            label="Su table name"
            variant="underlined"
            @update:model-value="updateModelValue"
          ></v-text-field>
        </v-col>
      </v-row>
      <span v-else>{{ suTable.name }}</span>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <SuTable :su-table="suTable" />
    </v-expansion-panel-text>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import SuTable from '@/components/suTable/SuTable.vue'

const props = defineProps({
  suTable: { type: Object, required: true },
  opened: { type: Array, required: true },
  dirtyClass: { type: String, required: false }
})

const emit = defineEmits(['update', 'set', 'toggle', 'right-click'])

const name = computed(() => props.suTable.name)

const isOpened = computed(() => props.opened.includes(props.suTable.id))

function updateModelValue(value) {
  emit('update')
  emit('set', { item: props.suTable, value, parameter: 'name' })
}

function togglePanel(e) {
  if (e.pointerType === 'mouse') {
    emit('toggle')
  }
}
</script>
